import styles from './ErrorPage.module.scss';

interface ErrorPageProps {
    title?: string;
    message: string;
}

const ErrorPage: React.FC<ErrorPageProps> = ({ title = 'Error', message }) => {
    return (
        <div className={styles.errorPage}>
            <h1>{title}</h1>
            <p>{message}</p>
        </div>
    );
};

export default ErrorPage;